<template>
  <div class="loseWeightPage">
    <div class="physique">
      <div class="physique-img">
        <left style="color: #ffffff"></left>
      </div>
    </div>
    <div class="top">
      <div class="top-l">
        <van-icon name="notes-o" />
        方案时间
      </div>
      <div class="top-r">
        <div class="top-r1">
          <van-dropdown-menu>
            <van-dropdown-item v-model="value1" :options="option1" @change="changeDate" />
          </van-dropdown-menu>
        </div>
        <div class="top-r2">
          <span class="r-new" v-if="option1.length > 0 && value1 == option1[0].value">最新</span>
          <van-icon name="arrow" />
        </div>
      </div>
    </div>
    <div class="card-box">
      <!-- 供给能 -->
      <div class="card">
        <div class="card-top">
          <div class="img-box">
            <img src="../assets/imgs/减重-icon1@2x.png" class="img-hw" />
          </div>
          <div class="img-font">供给量 (日)</div>
        </div>
        <div class="card-bk" v-if="detail.nengliang || detail.danbaizh || detail.zhifang || detail.tanshui">
          <div class="card-l">
            <div class="card-l1">{{ detail.nengliang }}</div>
            <div>千卡</div>
          </div>
          <div class="card-r">
            <div v-if="detail.danbaizhi">
              <span class="dian">蛋白质</span>
              <span>
                <span class="danwei">{{ detail.danbaizhi }}</span>
                克
              </span>
            </div>
            <div v-if="detail.zhifang">
              <span class="dian">脂肪</span>
              <span>
                <span class="danwei">{{ detail.zhifang }}</span>
                克
              </span>
            </div>
            <div v-if="detail.tanshui">
              <span class="dian">碳水化合物</span>
              <span>
                <span class="danwei">{{ detail.tanshui }}</span>
                克
              </span>
            </div>
          </div>
        </div>
        <div class="kongbai" v-else>
          <img src="../assets/imgs/empty@2x.png" alt="" />
          <div>未设置内容</div>
        </div>
        <div class="card-top">
          <div class="img-box">
            <img src="../assets/imgs/减重-icon1@2x.png" class="img-hw" />
          </div>
          <div class="img-font">全天饮水量</div>
        </div>
        <div class="card-inside-box" v-if="detail.water">
          <div class="card-inside">
            <div class="dian">每日饮水</div>
            <div>
              <span class="danwei">{{ detail.water }}</span>
              毫升
            </div>
          </div>
        </div>
        <div class="kongbai" v-else>
          <img src="../assets/imgs/empty@2x.png" alt="" />
          <div>未设置内容</div>
        </div>
        <div class="card-bottom" @click="goFoodPlan">查看详细方案</div>
      </div>
      <!-- 运动 -->
      <div class="card">
        <div class="card-top">
          <div class="img-box">
            <img src="../assets/imgs/减重-icon4@2x.png" class="img-hw" />
          </div>
          <div class="img-font">有氧运动</div>
        </div>
        <div class="sports-name">{{ detail.youyang_xm }}</div>
        <div class="card-inside-box" v-if="detail.youyang_zhou || detail.youyang_ci || detail.youyang_xinlv">
          <div class="card-inside" v-if="detail.youyang_zhou">
            <div class="dian">每周运动</div>
            <div>
              <span class="danwei">{{ detail.youyang_zhou }}</span>
              次
            </div>
          </div>
          <div class="card-inside" v-if="detail.youyang_ci">
            <div class="dian">每次</div>
            <div>
              <span class="danwei">{{ detail.youyang_ci }}</span>
              分钟
            </div>
          </div>
          <div class="card-inside" v-if="detail.youyang_xinlv">
            <div class="dian">心率达标</div>
            <div>
              <span class="danwei">{{ detail.youyang_xinlv }}</span>
              次/分钟
            </div>
          </div>
        </div>
        <div class="kongbai" v-else>
          <img src="../assets/imgs/empty@2x.png" alt="" />
          <div>未设置内容</div>
        </div>
        <div class="card-top">
          <div class="img-box">
            <img src="../assets/imgs/减重-icon4@2x.png" class="img-hw" />
          </div>
          <div class="img-font">抗阻运动</div>
        </div>
        <div class="sports-name">{{ detail.kangzu_xm }}</div>
        <div class="card-inside-box" v-if="detail.kangzu_zhou || detail.kangzu_ci || detail.kangzu_xinlv">
          <div class="card-inside" v-if="detail.kangzu_zhou">
            <div class="dian">每周运动</div>
            <div>
              <span class="danwei">{{ detail.kangzu_zhou }}</span>
              次
            </div>
          </div>
          <div class="card-inside" v-if="detail.kangzu_ci">
            <div class="dian">每次</div>
            <div>
              <span class="danwei">{{ detail.kangzu_ci }}</span>
              分钟
            </div>
          </div>
          <div class="card-inside" v-if="detail.kangzu_xinlv">
            <div class="dian">心率达标</div>
            <div>
              <span class="danwei">{{ detail.kangzu_xinlv }}</span>
              次/分钟
            </div>
          </div>
        </div>
        <div class="kongbai" v-else>
          <img src="../assets/imgs/empty@2x.png" alt="" />
          <div>未设置内容</div>
        </div>
        <div class="card-top">
          <div class="img-box">
            <img src="../assets/imgs/减重-icon4@2x.png" class="img-hw" />
          </div>
          <div class="img-font">运动建议</div>
        </div>
        <div class="sports">
          <div class="sports-advise" v-if="detail.sport_info">
            <pre>{{ detail.sport_info }}</pre>
          </div>
          <div class="kongbai" v-else>
            <img src="../assets/imgs/empty@2x.png" alt="" />
            <div>未设置内容</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { weightList } from "@/service/api";
import left from "../components/arrow-left";
export default {
  name: "loseWeight",
  components: { left },
  data() {
    return {
      detail: "",
      value1: 0,
      option1: [],
      detailList: [],
    };
  },
  created() {
    this.weightList();
  },
  methods: {
    weightList() {
      let params = {
        page: 1,
        limit: 20,
      };
      weightList(params)
        .then((res) => {
          console.log("详情", res);
          this.detailList = res.data.list;
          this.detailList.forEach((item, index) => {
            this.option1.push({
              text: item.daily,
              value: item.id,
            });
            if (this.$route.query.id == item.id) {
              this.detail = item;
              this.value1 = item.id;
            } else {
              this.detail = this.detailList[0];
              this.value1 = this.detailList[0].id;
            }
          });
        })
        .catch((err) => {
          this.$toast(err);
        });
    },
    changeDate(val) {
      console.log("?", val);
      this.detailList.forEach((item, index) => {
        if (val == item.id) {
          this.detail = item;
        }
      });
    },
    // 查看详细方案
    goFoodPlan() {
      this.$router.push({
        path: "/foodPlan",
        query: {
          id: this.detail.id,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .van-dropdown-menu__bar {
  box-shadow: none;
}
::v-deep .van-dropdown-menu__title::after {
  display: none;
}
::v-deep .van-dropdown-item__content {
  > :nth-child(1) {
    .van-cell__title::after {
      content: "最新";
      margin-left: 10px;
      padding: 0 7px;
      background: red;
      color: #fff;
    }
  }
}
.loseWeightPage {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background: #f5f5f5;
  .physique {
    width: 375px;
    height: 156px;
    background: url("../assets/imgs/减重-pic@2x.png");
    background-size: 100% auto;

    .physique-img {
      padding-top: 25px;
      margin-left: 16px;
    }
  }
  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    padding: 0 10px;
  }
  .top-r {
    display: flex;
    align-items: center;
    .top-r2 {
      display: flex;
      align-items: center;
      .r-new {
        display: inline-block;
        background: red;
        padding: 0 3px;
        color: #fff;
        font-size: 10px;
      }
    }
  }
  .card-box {
    padding: 20px 10px;
    .card {
      background: #fff;
      color: #a5a5a6;
      margin-bottom: 15px;
      padding: 10px;
      border-radius: 8px;
      .card-top {
        display: flex;
        .img-font {
          margin-left: 5px;
          font-size: 16px;
          font-weight: 600;
          text-align: left;
          color: #222222;
          line-height: 22px;
        }
        .img-box {
          width: 22px;
          height: 21px;
          .img-hw {
            width: 100%;
            height: 100%;
          }
        }
      }
      .sports-name {
        margin-top: 10px;
      }
      .card-bk,
      .card-inside-box {
        display: flex;
        background: #f9fafc;
        margin: 12px 0;
        border-radius: 4px;
      }
      .card-bk {
        padding: 10px;
        .card-l {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          width: 30%;
          min-height: 55px;
          border-radius: 4px;
          background: #9ab2fe;
          color: #fff;
          text-align: center;
          font-size: 12px;
          > div {
            width: 100%;
          }
          .card-l1 {
            margin-bottom: -17px;
            font-size: 22px;
          }
        }
        .card-r {
          width: 70%;
          padding-left: 10px;
          > div {
            display: flex;
            justify-content: space-between;
          }
        }
      }
      .card-inside-box {
        flex-wrap: wrap;
        padding: 5px 10px;
        .card-inside {
          display: flex;
          justify-content: space-between;
          width: 100%;
          padding: 10px 0;
          border-bottom: 1px solid #d9d9d9;
        }
        .card-inside:last-child {
          border-bottom: none;
        }
      }
      .dian {
        position: relative;
        padding-left: 10px;
      }
      .dian::before {
        content: "";
        display: block;
        width: 6px;
        height: 6px;
        background-color: #90abff;
        position: absolute;
        left: 0;
        top: 8px;
        border-radius: 50%;
      }
      .danwei {
        color: #373738;
      }

      .sports-advise {
        pre {
          word-wrap: break-word;
          white-space: pre-wrap;
          color: #000;
          font-size: 16px;
          line-height: 22px;
        }
      }
      .card-bottom {
        margin: 15px 0 5px;
        text-align: center;
        color: #4d8dff;
        font-weight: bold;
      }
    }
  }
  .kongbai {
    padding: 20px 0;
    color: #999;
    img {
      width: 80px;
      height: 80px;
      margin-bottom: 6px;
    }
    text-align: center;
  }
}
</style>
